import { render, staticRenderFns } from "./addSalesRecords.vue?vue&type=template&id=50ca1c9b&scoped=true"
import script from "./addSalesRecords.vue?vue&type=script&lang=js"
export * from "./addSalesRecords.vue?vue&type=script&lang=js"
import style0 from "./addSalesRecords.vue?vue&type=style&index=0&id=50ca1c9b&prod&lang=scss"
import style1 from "./addSalesRecords.vue?vue&type=style&index=1&id=50ca1c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ca1c9b",
  null
  
)

export default component.exports